<button mat-menu-item (click)="logout()">
  {{ "logoutComponent.logoutButton" | translate }}
</button>
